export default "__VITE_ASSET__CERHYALw__"